/**
 * Approximate geographic centers for Spanish provinces (by province name).
 * Used to center the map when a farm has no plots with geometry.
 */
const PROVINCE_CENTERS: Record<string, [number, number]> = {
  "álava": [42.85, -2.67],
  "albacete": [38.99, -1.86],
  "alicante": [38.35, -0.48],
  "almería": [36.84, -2.46],
  "asturias": [43.36, -5.85],
  "ávila": [40.66, -4.68],
  "badajoz": [38.88, -6.97],
  "barcelona": [41.39, 2.17],
  "burgos": [42.34, -3.70],
  "cáceres": [39.47, -6.37],
  "cádiz": [36.53, -6.29],
  "cantabria": [43.18, -3.99],
  "castellón": [39.99, -0.03],
  "ciudad real": [38.99, -3.93],
  "córdoba": [37.88, -4.77],
  "cuenca": [40.07, -2.13],
  "gerona": [41.98, 2.82],
  "girona": [41.98, 2.82],
  "granada": [37.18, -3.60],
  "guadalajara": [40.63, -3.16],
  "guipúzcoa": [43.31, -2.00],
  "gipuzkoa": [43.31, -2.00],
  "huelva": [37.26, -6.95],
  "huesca": [42.14, -0.41],
  "jaén": [37.77, -3.79],
  "la coruña": [43.37, -8.40],
  "a coruña": [43.37, -8.40],
  "la rioja": [42.29, -2.52],
  "las palmas": [28.10, -15.42],
  "león": [42.60, -5.57],
  "lérida": [41.62, 0.62],
  "lleida": [41.62, 0.62],
  "lugo": [43.01, -7.56],
  "madrid": [40.42, -3.70],
  "málaga": [36.72, -4.42],
  "murcia": [37.98, -1.13],
  "navarra": [42.82, -1.64],
  "orense": [42.34, -7.86],
  "ourense": [42.34, -7.86],
  "palencia": [42.01, -4.53],
  "pontevedra": [42.43, -8.64],
  "salamanca": [40.97, -5.66],
  "santa cruz de tenerife": [28.47, -16.25],
  "segovia": [40.95, -4.12],
  "sevilla": [37.39, -5.98],
  "soria": [41.76, -2.47],
  "tarragona": [41.12, 1.25],
  "teruel": [40.34, -1.11],
  "toledo": [39.86, -4.02],
  "valencia": [39.47, -0.38],
  "valladolid": [41.65, -4.72],
  "vizcaya": [43.26, -2.92],
  "bizkaia": [43.26, -2.92],
  "zamora": [41.50, -5.75],
  "zaragoza": [41.65, -0.88],
  "baleares": [39.57, 2.65],
  "illes balears": [39.57, 2.65],
  "islas baleares": [39.57, 2.65],
};

/**
 * Look up approximate center coordinates for a province name.
 * Returns [lat, lng] or undefined if not found.
 */
export const getProvinceCenterByName = (name: string): [number, number] | undefined => {
  if (!name) return undefined;
  return PROVINCE_CENTERS[name.toLowerCase().trim()];
};
